import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { State, process } from '@progress/kendo-data-query';
import { GridDataResult, SelectableSettings, RowArgs, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import {
  FileInfo,
  FileRestrictions,
  FileState,
  RemoveEvent,
  SuccessEvent,
} from '@progress/kendo-angular-upload';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { Observable, Subject, timer } from 'rxjs';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { CartService } from 'src/app/core/services/cart.service';
import { ItemService } from 'src/app/core/services/item.service';
import { UserService } from 'src/app/core/services/user.service';
import { QuoteService } from 'src/app/core/services/quote.service';
import { MasterDataService } from 'src/app/core/services/master-data.service';
import { HelperService } from 'src/app/core/services/helper.service';
import {
  Finish,
  IAddItemToKdQuoteItemListBody,
  ICartItem, IDeleteKdQuoteItemBody,
  IEmptyQuoteItemsBody, IExtrusion, IFinish,
  IFilterItemRequest, IGetKdQuoteDetailBody,
  IItemList, IUser, IQuoteItem,
  ItemSuggestion, QuoteItem, ICopyQuoteRequestBody,
  IMasterData, ICreateQuoteItemRevisionBody, IQuote,
  IAddQuoteToCartBody, IAddQuoteItemToCartItemListBody,
  IUpdateItemToQuoteBody,
  IBaseResponse,
  QuoteImportExcel,
  IImportExcelUpload,
  IQuoteImportExcel,
  IKDQuoteDetailLbl,
  IPrintMaterialProposalBody,
  ICheckOutOrderDetailsLbl,
  ICheckOutProcessModel,
  CheckOutProcessModel,
  IState,
  IDropDownData,
  IOrderDetail,
  OrderDetailsFormValidate,
  IOrderDetailsFormValidate,
  OrderDetail,
  MasterData,
  Customer,
  ICustomer,
  IGetAllSupportDataForCheckOutOrderDetail,
  ICountry,
  AddressType,
  ICheckOutLabel,
  ITaxCertificates,
  ICreditCardFreightAmount
} from 'src/app/core/models';
import { Info } from '../../../../../../core/common';
import { ActivatedRoute, Router } from '@angular/router';
import { clone, isNaN, isNumber } from 'lodash';
import { environment } from '../../../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ProductService } from '../../../../../../core/services/product.service';
import { V6productService } from '../../../../../../core/services/v6product.service';
import { LanguageTranslationService } from '../../../../../../core/services/language-translation.service';
import { CustomerService } from '../../../../../../core/services/customer.service';
import { tap, map } from 'rxjs/operators';
import { CheckoutService } from '../../../../../../core/services/checkout.service';

declare const gtag: Function;

@Component({
  selector: 'app-quick-add-quote',
  templateUrl: './quick-add-quote.component.html',
  styleUrls: ['./quick-add-quote.component.scss']
})
export class QuickAddQuoteComponent implements OnInit, AfterContentChecked {

  //#region variables
  public jobName: string;
  public po: string;
  public isEmptyPaint: boolean;
  public isEmptyPaintInGrid: boolean;
  public isHaveErrorInGrid: boolean;
  copyQuoteForm: FormGroup;
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public saveInProcess: boolean;
  public infoMessage: Info = new Info();
  quoteItemGridLoading: boolean = false;
  isQuoteToCartLoading: boolean = false; isCreateNewRevisionLoading: boolean;
  isPrintMaterialProposalLoading: boolean;
  public paintValue: Array<any> = [];
  quoteDetailTxt: IKDQuoteDetailLbl;
  alertMessage: string;
  existingQuoteItemInCartAlertBox: boolean;
  gridHeight: string = '570';
  public pageable = true;
  scrHeight: any;
  scrWidth: any;

  public filteredTaxCertificatesItems: ITaxCertificates[];
  public taxertificatesItemsOrg: ITaxCertificates[];
  public searchTaxCertificatesItems: ITaxCertificates;
  hasPlaceOrderAccess: boolean = false;
  public cCPaymentConfirmationDialog: boolean = false;
  public creditCardCharge: number = 0;
  public creditCardTotalAmount: number = 0;
  //#endregion

  //#region properties
  protected get loggedInUser(): IUser {
    return this.userService.readUserObject;
  }

  public get selectedQuoteHeader() {
    return this.quoteService.selectedQuoteHeader;
  }
  //#endregion
  //#region Constructor & ngOninit
  constructor(
    private cartService: CartService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private appNotify: AppNotifyService,
    private router: Router,
    private route: ActivatedRoute,
    private itemService: ItemService,
    private quoteService: QuoteService,
    private masterService: MasterDataService,
    private sanitizer: DomSanitizer,
    private productService: ProductService,
    private v6productService: V6productService,
    private languageTranslationService: LanguageTranslationService,
    private cdref: ChangeDetectorRef,
    private masterDataService: MasterDataService,
    private customerService: CustomerService,
    private checkoutService: CheckoutService,
    private helperService: HelperService
  ) {
    this.getScreenSize();
    this.createEditFormGroup = this.createEditFormGroup.bind(this);
    this.removeConfirmation = this.removeConfirmation.bind(this);
  }

  //#region import Window Modal
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    //console.log(this.scrHeight, this.scrWidth);
    if (this.scrWidth <= 1024) {
      // this.gridHeight = '570';
      this.pageable = false;
      this.gridState.take = 99;
    }
    else {
      //this.gridHeight = 'auto';
      this.pageable = true;
      this.gridState.take = 10;
    }
  }

  ngOnInit(): void {
    this.quoteService.KD_Quote_Has_Error = false;
    this.paintDisclaimerMsg = this.quoteService.paintDisclaimerMsg;
    this.loadLanguageTranslationData();
    this.copyQuoteForm = this.formBuilder.group({
      jobName: new FormControl(),
      marketSegment: new FormControl(),
      leed: new FormControl(false)
    });
    if (this.quoteService.selectedQuoteHeader.quoteCommonId === undefined || this.quoteService.selectedQuoteHeader.quoteCommonId === null) {
      this.router.navigate(['../'], { relativeTo: this.route });
    }
    else {
      this.loadQuoteItems();
    }
    this.paintValue = this.masterService.getPaintValues();
    // QuickAdd Form Init.
    this.directItemEntryFormGroup = this.formBuilder.group({
      quantity: [1, Validators.required],
      quickAddItemSearchBox: ['', Validators.required],
      ctrlQuickAddFinish: ['', Validators.required],
      unitOfMeasure: ['EA'],
      itemNumber: [''],
      ctrlQuickAddExtrusion: [''],
      ctrlQuickAddPaint: ['']
    });

    this.hasPlaceOrderAccess = this.userService.hasAccessToPlaceOrder();
    //Validate CC Customer
    if (this.userService.isCheckoutCCCustomer())
      this.checkOutCCCustomer = true;
    if (this.userService.isCheckoutCConlyCustomer())
      this.checkOutCConlyCustomer = true;
    if (this.userService.getFreightEstimateFlag())
      this.freightEstimateFlag = true;
    if (this.userService.getFreightEstimateNoteFlag())
      this.freightEstimateNoteFlag = true;
  }
  loadQuoteItems() {
    // load my quote items.
    this.quoteItemGridLoading = true;
    const body: IGetKdQuoteDetailBody = {
      quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId
    }
    this.quoteService.getKdQuoteDetail(body).subscribe((quoteItems) => {
      this.loadKdQuoteItemssGrid()
      this.quoteItemGridLoading = false;
    }, error => {
      this.quoteItemGridLoading = false;
    });
  }
  //#endregion
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "quickAddLbl" },
      { controlName: "addQuoteToCartLbl" },
      { controlName: "cancelLbl" },
      { controlName: "clearSelectionLbl" },
      { controlName: "copyQuoteLbl" },
      { controlName: "createNewRevisionLbl" },
      { controlName: "saveLbl" },
      { controlName: "closeLbl" },
      { controlName: "deleteQuoteConfirmLbl" },
      { controlName: "copyLbl" },
      { controlName: "editLbl" },
      { controlName: "expiredDateLbl" },
      { controlName: "exportExcelLbl" },
      { controlName: "exportPDFLbl" },
      { controlName: "extPriceLbl" },
      { controlName: "extrusionLbl" },
      { controlName: "finishLbl" },
      { controlName: "itemDescriptionLbl" },
      { controlName: "itemNumLbl" },
      { controlName: "jobNameLbl" },
      { controlName: "jobNumberLbl" },
      { controlName: "leedLbl" },
      { controlName: "lineLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "multiplierLbl" },
      { controlName: "itemLbl" },
      { controlName: "pleaseConfirmLbl" },
      { controlName: "printMaterialProposal" },
      { controlName: "quantityLbl" },
      { controlName: "sizeLbl" },
      { controlName: "successAddingQuoteToCart" },
      { controlName: "totalPriceLbl" },
      { controlName: "unitLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "uomLbl" },
      { controlName: "updateLbl" },
      { controlName: "paintLbl" },
      { controlName: "actionLbl" },
      { controlName: "importLbl" },
      { controlName: "emptyQuoteLbl" },
      { controlName: "deleteConfirmText1" },
      { controlName: "yesLbl" },
      { controlName: "noLbl" },
      { controlName: "quoteUpdateSuccessLbl" },
      { controlName: "errorOccuredLbl" },
      { controlName: "nothingToRemoveLbl" },
      { controlName: "emptyQuoteMessage" },
      { controlName: "revisionCreatedLbl" },
      { controlName: "copyQuoteMessage" },
      { controlName: "deleteConfirmText2" },

    ];
    const componentName = "quoteDetail";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.quoteDetailTxt = response[response.length - 1];
    }

  }

  //#endregion
  //#region label declaration
  quickAddQuote = {
    quickAddLbl: 'Quick Add',
    addQuoteToCartLbl: 'Add Quote to Cart',
    cancelLbl: 'Cancel',
    clearSelectionLbl: 'Clear Selection',
    copyQuoteLbl: 'Copy Quote',
    createNewRevisionLbl: 'Create New Revision',
    saveLbl: 'Save',
    closeLbl: 'Close',
    deleteQuoteConfirmLbl: 'Are you sure you want to delete everything from your quote?',
    copyLbl: 'Copy',
    editLbl: 'Edit',
    expiredDateLbl: 'Expired Date',
    exportExcelLbl: 'Export To Excel',
    exportPDFLbl: 'Export To PDF',
    extPriceLbl: 'Ext Price',
    extrusionLbl: 'Extrusion',
    finishLbl: 'Finish',
    itemDescriptionLbl: 'Description',
    itemNumLbl: 'Item Number',
    jobNameLbl: 'Job Name',
    jobNumberLbl: 'Job Number',
    leedLbl: 'LEED',
    lineLbl: 'Line #',
    listPriceLbl: 'List Price',
    marketSegmentLbl: 'Market Segment',
    multiplierLbl: 'Multiplier',
    itemLbl: 'Item #',
    pleaseConfirmLbl: 'Please Confirm',
    printMaterialProposal: 'Print Material Proposal',
    quantityLbl: 'Quantity',
    sizeLbl: 'Size',
    successAddingQuoteToCart: 'Quote Item is added to Cart.',
    totalPriceLbl: 'Total Price',
    unitLbl: 'Unit',
    unitPriceLbl: 'Unit Price',
    uomLbl: 'UOM',
    updateLbl: 'Update',
    paintLbl: 'Paint',
    actionLbl: 'Actions',
    importLbl: 'Import',
    emptyQuoteLbl: 'Empty Quote',
    deleteConfirmText1: ' Are you sure you want to delete quote with',
    yesLbl: 'Yes',
    noLbl: 'No',
    quoteUpdateSuccessLbl: 'Quote Item has been updated!',
    errorOccuredLbl: '"An error occured. Please try again"',
    nothingToRemoveLbl: "'There's nothing to remove'",
    emptyQuoteMessage: 'Your Quote is empty now.',
    revisionCreatedLbl: 'Quote is created with new Revision',
    copyQuoteMessage: 'Atleast one item is required to copy the quote',
    deleteConfirmText2: 'Are you sure you want to delete everything from your quote?',
    expressCheckoutBtnText: 'Express Checkout',
    invalidQuotetext: "Quote Item is not valid"
  }
  //#endregion
  public showQuickAdd = false; // TODO Set to false when not working on the quick add.
  public directItemEntryFormGroup: FormGroup;
  public itemsLoading = false;
  public filteredItems: Array<ItemSuggestion> = new Array<ItemSuggestion>();
  public quickAddVirtual: any = { itemHeight: 40 };
  protected decimals: number = 0;
  protected autoCorrect: boolean = true;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  public quoteItemsView: GridDataResult;
  public gridData: IQuoteItem[] = [];
  public showQuoteDeleteConfirmBox: boolean = false;
  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    this.showQuoteDeleteConfirmBox = true;
    return this.removeConfirmationSubject;
  }
  protected confirmRemove(shouldRemove: boolean): void {
    this.showQuoteDeleteConfirmBox = false;
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      const quoteItemCommonId: string = this.gridItemToRemove.quoteItemCommonId;
      const quoteCommonId: string = this.gridItemToRemove.quoteCommonId;
      this.quoteItemRemoveHandler(quoteCommonId, quoteItemCommonId);
      this.isRowSelected = (e: RowArgs) => false;
    } else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.isRowSelected = (e: RowArgs) => false;
    }
  }

  public handlePaintChange(event, dataItem) {
    dataItem.isEmptyPaint = false;
    dataItem.paint = event.value;
    dataItem.paintName = event.name;
    //if (event) {

    //  dataItem.paintValue = this.masterService.getPaintValues().filter(
    //    (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
    //  );
    //}
    //else {
    //  dataItem.paintValue = this.masterService.getPaintValues();
    //}
    dataItem.updatedQuantity = dataItem.quantity;
    //this.updateItemToKdQuote(dataItem);
    //check if item is already exist and update based on that
    this.setUpdateItem(dataItem);
  }
  protected quoteItemRemoveHandler(quoteCommonId: string, quoteItemCommonId: string) {
    const body: IDeleteKdQuoteItemBody = {
      quoteCommonId: quoteCommonId,
      quoteItemCommonId: quoteItemCommonId
    }
    this.gridItemToRemove.updateInProgress = true;
    this.quoteService.deleteKdQuoteItem(body).subscribe((deletedQuote) => {
      this.gridItemToRemove.updateInProgress = false;
      console.log(deletedQuote);
      if (deletedQuote) {
        this.appNotify.notify(NotifyType.SUCCESS, "Selected quote item has been removed.");
        if (this.gridData) {
          //This is a Local Remove
          this.quoteService.removekdQuoteItem = quoteItemCommonId;
          this.loadKdQuoteItemssGrid();
          this.gridItemToRemove = null;

        }
      }
      else {
        this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
      }
    }, error => {
      this.gridItemToRemove.updateInProgress = false;
      this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }
  public gridItemToRemove: IQuoteItem;

  private getItemListBody: IFilterItemRequest = {
    ////categoryId: '',
    //finishId: '',
    customerNumber: this.userService.readUserObject.customerNumber,
    itemNumber: '',
    longItemNumber: '',
    pageNo: 1,
    searchQuery: '',
    skip: 0,
    take: 1,
    finishFilter: [],
    categoryFilter: [],
    sort: [
      {
        field: '',
        dir: 'asc',
      },
    ],
    filter: []
  };

  public editFormGroup: FormGroup;
  protected gridState: State = {
    sort: [
      {
        field: 'lineNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
  };

  //#region Edit QuoteItem grid Functions
  public InfoUnitlbl = this.cartService.listItems[0];
  public InfoQty = this.cartService.listItems[1];
  public InfoFinish = this.cartService.listItems[2];
  public InfoFrame = this.cartService.listItems[3];
  public InfoTransom = this.cartService.listItems[4];
  public InfoDow = this.cartService.listItems[5];
  public InfoDoh = this.cartService.listItems[6];
  public InfoDoortype = this.cartService.listItems[7];
  public InfoDoorhand = this.cartService.listItems[8];
  public InfoDoorhinge = this.cartService.listItems[9];
  public InfoDoorlock = this.cartService.listItems[10];
  public infoOpened = false;
  public selectableSettings: SelectableSettings;
  //#endregion

  //#region Quick Add
  selectedItemDescription: any;
  selectedItemNumber: string;
  selectedQuickAddItem: ItemSuggestion;
  ctrlQuickAddFinish: FormControl;
  quickAddAvailableFinishes: IFinish[] = [];
  quickAddSelectedFinishValue: string;
  quickAddAvailableSizes: IExtrusion[];
  quickAddSelectedSize: string;
  quickAddSelectedItem: IItemList;
  loadingQuickAddFinsh: boolean;

  public defaultFinish: IFinish = new Finish();
  public defaultPaint: any = {};
  public quickAddDefaultFinish: IFinish = null;
  public quickAddDefaultPaint: any = null;
  public isDefaultFinishAvailable: Boolean = false;
  public isDefaultPaintAvailable: Boolean = false;


  public defaultExtrusion: IExtrusion;
  public quickAddDefaultExtrusion: IExtrusion = null;
  public thereAreMultipleExtrusionOptions: Boolean = false;
  public mySelection: any[] = [];

  public get quickform() {
    return this.directItemEntryFormGroup.controls;
  }
  public get quickAddAvailableSizesOnSelectedFinish(): IExtrusion[] {
    const selectedFinish = this.directItemEntryFormGroup.controls
      .ctrlQuickAddFinish.value;

    if (selectedFinish == null || selectedFinish) {
      if (this.quickAddSelectedItem) {
        if (this.quickAddSelectedItem.availableFinish) {

          if (this.quickAddSelectedItem.availableFinish.length > 0) {
            this.quickAddSelectedItem.availableFinish = this.quickAddSelectedItem.availableFinish
              .map(r => ({ value: r.value === null ? null : r.value, name: r.name, eurrentExtrusionLength: r.eurrentExtrusionLength, availableSizes: r.availableSizes }) as IFinish);
          }

          const finishIndata = this.quickAddSelectedItem.availableFinish.find((r) => r.value === selectedFinish);
          if (finishIndata) {

            if (finishIndata.availableSizes) {
              if (finishIndata.availableSizes.length > 0) {
                finishIndata.availableSizes = finishIndata.availableSizes
                  .map(r => ({ value: r.value === null ? '' : r.value, basePrice: r.basePrice }) as IExtrusion);
              }

              if (finishIndata.availableSizes.length === 1) {
                // this.defaultExtrusion = finishIndata.availableSizes[0];
                this.quickform.ctrlQuickAddExtrusion.setValue(finishIndata.availableSizes[0].value);
              } else {                            // Point to remember
                // this.defaultExtrusion = { value: "NA", basePrice: 0 };
                this.quickform.ctrlQuickAddExtrusion.setValue('');
                return [{ value: null, basePrice: 0, listPrice: 0 }];
              }
            }
            return finishIndata.availableSizes;
          }
        } else {
          this.quickAddAvailableFinishes = [];
          this.quickAddAvailableFinishes.push(
            {
              value: null, name: '', availableSizes: [{ value: null, basePrice: 0, listPrice: 0 }], eurrentExtrusionLength: null, basePrice: 0, listPrice: 0
            });
        }
      }
    }
    return [];
  }
  public get quickAddfinishDescription(): IFinish {
    const selectedFinish = this.directItemEntryFormGroup.controls
      .ctrlQuickAddFinish.value;
    if (selectedFinish == null || selectedFinish) {
      if (this.quickAddSelectedItem) {
        if (this.quickAddSelectedItem.availableFinish) {
          return this.quickAddSelectedItem.availableFinish.find(
            (r) => r.value === selectedFinish
          );
        }
      }
    }
    return null;
  }

  handleItemFilter(searchQuery: string) {

    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.itemsLoading = true;
      this.itemService
        .getItemSuggestions({
          searchstring: searchQuery,
          categoryId: -1,
        })
        .subscribe((resp: ItemSuggestion[]) => {
          this.filteredItems = resp
          this.itemsLoading = false;
        });
    }
  }
  itemSelected(item) {
    if (!item) {
      return;
    }
    this.selectedItemDescription = item;
    this.selectedQuickAddItem = this.filteredItems.find((r) =>
      r.fullDescription.startsWith(item)
    );
    if (this.selectedQuickAddItem && this.selectedQuickAddItem.itemNumber) {
      this.loadItemDetails(this.selectedQuickAddItem.itemNumber);
    } else {
      this.directItemEntryFormGroup.controls.quickAddItemSearchBox.setValue('');
    }
  }

  //async onQuickAddToQuoteItemList() {
  //  //validate and proceed
  //  const quoteItem = new QuoteItem();
  //  quoteItem.itemNumber = this.selectedQuickAddItem.itemNumber;
  //  quoteItem.finishValue = (this.quickform.ctrlQuickAddFinish.value as string) === null ? '' : (this.quickform.ctrlQuickAddFinish.value as string);
  //  if (this.quickform.ctrlQuickAddFinish.value == '22') {
  //    const selectedPaint = this.quickform.ctrlQuickAddPaint.value;
  //    if (!selectedPaint) {
  //      this.isEmptyPaint = true;
  //      return;
  //    } 
  //  }
  //  quoteItem.finish = this.quickAddfinishDescription ? this.quickAddfinishDescription.name : quoteItem.finish;
  //  quoteItem.size = (this.quickform.ctrlQuickAddExtrusion.value as string) === null ? null : (this.quickform.ctrlQuickAddExtrusion.value as string);
  //  quoteItem.quantity = this.quickform.quantity.value;
  //  quoteItem.lineNo = this.quoteService.kdQuoteItems.length + 1;
  //  quoteItem.paint = this.quickform.ctrlQuickAddPaint.value;
  //  const longItemNumber = quoteItem.itemNumber + '-' + quoteItem.finishValue + '-' + quoteItem.size;
  //  //check if it is update or add
  //  const temp = this.scanQuoteToGetItem(longItemNumber);
  //  //v6referenceNumber of finish selected
  //  if (!this.itemService.finishes) {
  //    const data = await this.itemService.getFinishesNew().toPromise();
  //  }
  //  const FinishArray = this.itemService.finishes;
  //  var v6ReferenceValue = "";
  //  //checking length
  //  if (FinishArray.length>0) {
  //    v6ReferenceValue = FinishArray.find(x => x.value == quoteItem.finishValue).v6ReferenceValue
  //  } 
  //  const body: IAddItemToKdQuoteItemListBody = {
  //    quoteCommonId: this.selectedQuoteHeader.quoteCommonId,
  //    finishValue: quoteItem.finishValue,
  //    finish: quoteItem.finish,
  //    V6ReferenceValue: v6ReferenceValue,
  //    size: quoteItem.size,
  //    quantity: quoteItem.quantity,
  //    itemNumber: quoteItem.itemNumber,
  //    lineNo: quoteItem.lineNo,
  //    paint: quoteItem.paint
  //  }
  //  // this.quoteItemGridLoading = true;
  //  //decide if it is update or add then call respective api
  //  this.quoteService.addItemToKdQuoteItemList(body).subscribe((r: any) => {
  //    this.appNotify.notify(
  //      NotifyType.SUCCESS,
  //      'Item has been added to the Quote!'
  //    );
  //    this.loadKdQuoteItemssGrid();
  //    this.onQuickAddReset();
  //    //this.quoteItemGridLoading = false;
  //  },
  //    (error) => {
  //      this.appNotify.notify(NotifyType.ERROR, "An Error Occured!");
  //      this.quoteItemGridLoading = false;
  //    });


  //}



  //#region Grid data binding
  private loadKdQuoteItemssGrid(): void {
    this.setCurrentSizeProperty(this.quoteService.kdQuoteItems);
    this.quoteItemGridLoading = true;
    this.quoteItemsView = process(this.quoteService.kdQuoteItems, this.kdQuoteItemGridstate);
    this.quoteItemGridLoading = false;
    this.isPaintDisclaimerApplicable();
  }

  //#endregion
  //#region pagination, sorting,filtering for KD quote grid

  public kdQuoteItemGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'quoteNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };


  protected kdQuoteItemGridSortChange(sort): void {
    this.kdQuoteItemGridstate.sort = sort;
    this.loadKdQuoteItemssGrid();
  }

  protected kdQuoteItemGridPageChange({ skip, take }: PageChangeEvent): void {
    this.kdQuoteItemGridstate.skip = skip;
    this.kdQuoteItemGridstate.take;
    this.loadKdQuoteItemssGrid();
  }

  public kdQuoteItemDataStateChange(state: DataStateChangeEvent): void {
    this.kdQuoteItemGridstate = state;
    this.loadKdQuoteItemssGrid();
  }

  //#endregion

  public updateItemToKdQuote(dataItem: QuoteItem) {
    //WRITE VALIDATE LOGIC
    const body: IUpdateItemToQuoteBody = {
      updatedQuantity: dataItem.updatedQuantity,//hddd test
      lineNo: 0,//hddd test
      quoteCommonId: dataItem.quoteCommonId,
      quoteItemCommonId: dataItem.quoteItemCommonId,
      finishValue: dataItem.finishValue,
      finish: dataItem.finish,
      size: dataItem.size,
      quantity: dataItem.quantity,
      itemNumber: dataItem.itemNumber,
      paint: dataItem.paint,
      paintName: dataItem.paintName,
      customerNumber: this.loggedInUser.customerNumber,
      quoteItemCommonIdToDelete: dataItem.quoteItemCommonIdToDelete
    };

    this.quoteItemGridLoading = true;
    this.quoteService.updateItemToKdQuote(body).subscribe((quoteItem) => {
      if (quoteItem) {
        this.appNotify.notify(
          NotifyType.SUCCESS,
          'QuoteItem has been updated!'
        );

        this.loadKdQuoteItemssGrid();
        this.quoteItemGridLoading = false;
      }
      else {
        this.appNotify.notify(
          NotifyType.ERROR,
          "An error occured. Please try again"
        );
        this.quoteItemGridLoading = false;
      }
    }, error => {
      this.appNotify.notify(
        NotifyType.ERROR,
        "An error occured. Please try again"
      );
      this.quoteItemGridLoading = false;
    });

  }
  setUpdateItem(dataItem: QuoteItem) {
    //Create a long itrem number.
    var longItemNumber = dataItem.itemNumber;
    if (dataItem.finishValue && dataItem.finishValue.length > 0) {
      longItemNumber = longItemNumber + '-' + dataItem.finishValue;
    }
    if (dataItem.size && dataItem.size.length > 0) {
      longItemNumber = longItemNumber + '-' + dataItem.size;
    }
    //Check that Longitem number exist or not
    var temp = this.scanQuoteToGetDuplicateItem(longItemNumber, dataItem.paint, dataItem.quoteItemCommonId);
    //if exist then update quantity and send that item to update
    if (temp) {
      temp.updatedQuantity = temp.quantity + dataItem.quantity;
      // send dataitem.quoteItemQuomonId  for delete the item
      temp.quoteItemCommonIdToDelete = dataItem.quoteItemCommonId;
      this.updateItemToKdQuote(temp);
    } else {
      dataItem.updatedQuantity = dataItem.quantity;
      this.updateItemToKdQuote(dataItem);
    }
  }
  public handleQuoteItemFinishChange(event, dataItem: QuoteItem) {
    dataItem.finishValue = event.value;
    dataItem.finish = event.name;
    this.isEmptyPaintInGrid = false;
    //this.isHaveErrorInGrid = false;
    if (event.value == 22) {
      dataItem.paint = '';
      dataItem.paintName = '';
      dataItem.isEmptyPaint = true;
      this.isEmptyPaintInGrid = true;
      return;
    }
    dataItem.currentSizes = dataItem.availableFinishes.find(x => x.value === event.value).availableSizes;
    if (dataItem.currentSizes.length === 1) {
      dataItem.size = dataItem.currentSizes[0].value;
      dataItem.basePrice = dataItem.currentSizes[0].basePrice;
    } else if (dataItem.currentSizes.length > 1) {
      dataItem.size = '';
      dataItem.basePrice = 0;
    }
    //check if item item already exist and update based on that
    this.setUpdateItem(dataItem);
    console.log(dataItem.currentSizes);

  }
  public handleQuoteItemSizeChange(event, dataItem: QuoteItem) {
    dataItem.updatedQuantity = dataItem.quantity;
    //this.updateItemToKdQuote(dataItem);
    //check if item item already exist and update based on that
    this.setUpdateItem(dataItem);
  }

  handleQuoteItemQtyUpdate(dataItem: QuoteItem) {
    if (dataItem.updatedQuantity) {
      if (dataItem.quantity !== dataItem.updatedQuantity) {
        //dataItem.quantity = dataItem.updatedQuantity;
        this.updateItemToKdQuote(dataItem);
      }
    }
  }
  handleQuoteItemQtyChanged(event, dataItem: QuoteItem) {
    // change loacllly
    console.log(event);
    dataItem.updatedQuantity = event;
    //dataItem.extendedPrice = dataItem.basePrice * dataItem.cmp * dataItem.quantity * 0.94;
  }

  change(dataItem: QuoteItem, event: number) {
    //this.qtyVal = event;
    this.quoteItemGridLoading = true;
    dataItem.updatedQuantity = event;
    this.handleQuoteItemQtyUpdate(dataItem);
  }

  public get quoteItemsTotal(): number {
    if (this.quoteService.kdQuoteItems) {
      return (this.quoteService.kdQuoteItems as QuoteItem[]).map(
        item => item.extendedPrice
      ).reduce((a, b) => +(a + b), 0);
    }
    return 0;
  }

  getExtendedPrice(dataItem: QuoteItem): number {
    dataItem.extendedPrice = dataItem.basePrice * dataItem.cmp * dataItem.quantity * 0.94;
    return dataItem.extendedPrice;
  }

  //#endregion



  //public handlePaintChangeQuickAdd(event, dataItem: QuoteItem): void {
  //  console.log(event);
  //  this.quickAddSelectedItem.paints = event.value;
  //  this.isEmptyPaint = false;
  //}

  public handlePaintFilter(event, dataItem) {
    if (event) {
      dataItem.paintValue = this.masterService.getPaintValues().filter(
        (s) => s.name.toLowerCase().indexOf(event.toLowerCase()) !== -1
      );
    }
    else {
      dataItem.paintValue = this.masterService.getPaintValues();
    }
  }


  public paintChosen(paintValue: string): any {
    if (this.quickAddSelectedItem) {
      //if (this.quickAddSelectedItem.paints) {
      const tempPaint = this.paintValue.find(r => r.value === paintValue);
      if (tempPaint) {
        return tempPaint;
      }
      // }
    }
    return null;
  }

  updateQuoteItems(quoteItem: IQuoteItem) {

    if (this.gridData) {
      const temp = (this.gridData as QuoteItem[]).find(x => x.longItemNumber === quoteItem.longItemNumber);
      if (temp) {
        temp.quantity = quoteItem.quantity;
      }
      else {
        this.gridData.push(quoteItem);
      }
    }
    this.bindGridData();
  }

  updateExtendedPrice(quantity: number, baseprice: number): number {
    return quantity * baseprice;
  }
  gridUpdateOnQuickAddSubmit(quoteItems: QuoteItem[]) {
    if (quoteItems) {
      quoteItems.forEach((quoteItem, index) => {
        this.updateQuoteItems(quoteItem);
      });
    }
  }
  scanQuoteToGetItem(longItemNumber: string) {
    const temp = this.quoteService.kdQuoteItems.find(x => x.longItemNumber === longItemNumber);
    if (temp) {
      return temp;
    } else { return null; }
  }
  scanQuoteToGetDuplicateItem(longItemNumber: string, paint: string, quoteItemCommonId: string) {
    var item: QuoteItem;
    let temp = this.quoteService.kdQuoteItems.filter(x => (x.longItemNumber === longItemNumber && x.quoteItemCommonId != quoteItemCommonId));
    if (temp && temp.length > 1 && paint) {
      item = temp.find(x => x.paint === paint);
    } else if (temp && temp.length > 0) {
      item = temp[0];
    }
    if (item) {
      return item;
    } else { return null; }
  }
  //when a paint is defaulted, and then when itemChanged to one which doesnt have paint, the paintdropdown is not getting reset/removed
  loadItemDetails(itemNumber: string) {
    this.getItemListBody.itemNumber = itemNumber;
    this.loadingQuickAddFinsh = true;
    this.itemService
      .filterItems(this.getItemListBody as IFilterItemRequest)
      .subscribe((data) => {
        console.log(data);
        this.quickAddSelectedItem = data.currentPageData[0]; // put check for length
        console.log(data.currentPageData[0]);
        this.quickAddAvailableFinishes = this.quickAddSelectedItem.availableFinish;
        this.quickform.ctrlQuickAddFinish.setValue(null);
        this.quickform.ctrlQuickAddPaint.setValue(null);
        this.showPaint = false;
        console.log(this.showPaint + "inside loadItemDetails");
        this.quickAddSetDefaultValue();
        if (this.quickAddAvailableFinishes.length === 0) {
          // put check for null & &also put check for default finish is set or not
          this.quickAddSelectedFinishValue = this.quickAddAvailableFinishes[0].value;
          // this.ctrlQuickAddFinish.setValue(this.quickAddSelectedFinishValue);
        }
        this.loadingQuickAddFinsh = false;
      });
  }
  protected quickAddSetDefaultValue() {
    if (this.quickAddAvailableFinishes) {
      // if Finish is only one Finish
      if (this.quickAddAvailableFinishes.length === 1) {
        this.quickform.ctrlQuickAddFinish.setValue(this.quickAddAvailableFinishes[0].value);

      } else if (this.quickAddAvailableFinishes.length > 1) {  // if Finish is more than one item then Default matching
        if (this.defaultFinish) {
          const tempfinish = this.quickAddAvailableFinishes.find(r => r.value == this.defaultFinish.value);
          if (this.defaultPaint) {
            this.showPaint = true;
            this.quickform.ctrlQuickAddPaint.setValue(this.defaultPaint.value);
          }
          else {
            this.showPaint = false;
            this.quickform.ctrlQuickAddPaint.setValue(null);
          }
          if (tempfinish) {
            this.quickform.ctrlQuickAddFinish.setValue(tempfinish.value);
          }
        } else {
          this.quickform.ctrlQuickAddFinish.setValue(null);
          this.showPaint = false;
          this.quickform.ctrlQuickAddPaint.setValue(null);
        }
      } else {
        this.quickAddAvailableFinishes = [];
        this.showPaint = false;
        this.quickAddAvailableFinishes.push(
          {
            value: null, name: '', availableSizes: [{ value: null, basePrice: 0, listPrice: 0 }], eurrentExtrusionLength: null, basePrice: 0, listPrice: 0
          });
        this.quickform.ctrlQuickAddFinish.setValue(this.quickAddAvailableFinishes[0].value);
      }
    }
  }

  //finishSelected(finish: string) {
  //  console.log(finish);
  //  if (finish === '22') {
  //    this.showPaint = true;
  //   // this.quickAddSelectedItem.paints = this.paintValue;
  //  } else {
  //    this.showPaint = false;
  //    this.quickform.ctrlQuickAddPaint.reset();
  //    this.isEmptyPaint = false;
  //  }
  //  const selectedFin = this.quickAddSelectedItem.availableFinish.find(x => x.value === finish); // right now
  //  if (selectedFin) {
  //    this.quickAddAvailableSizes = selectedFin.availableSizes;
  //  }
  //}

  sizeSelected(event) {
    this.quickAddSelectedSize = event;
  }

  //#endregion

  //#region Common Grid Events
  public bindGridData() {
    this.quoteItemsView.data = this.gridData.slice(this.gridState.skip, this.gridState.skip + this.gridState.take);
    this.quoteItemsView.total = this.gridData.length;
  }
  public createEditFormGroup(args: any): FormGroup {
    if (args.dataItem) {
      const item = args.dataItem;
      // this.cartService.getItemOptions(item.itemNumber);
      this.editFormGroup = this.formBuilder.group({
        quantity: item.quantity,
        finishId: item.finishId,
        extrusionId: item.extrusionId,
      });
      return this.editFormGroup;
    }
  }
  public pageChange(event) {
    console.log(event);
    this.gridState.skip = event.skip;
    this.gridState.take = event.take;
    this.bindGridData();
  }
  public pageSizeChangeHandler(pageSize: number): void {
    this.gridState.take = pageSize;
    this.bindGridData();
  }
  public toggleShowQuickAdd(): void {
    this.showQuickAdd = !this.showQuickAdd;
  }

  //#endregion
  //#endregion
  public enableEdit = true;
  showInfo: boolean = true;
  public showPaint = false;
  public onToggle(): void {
    this.showInfo = !this.showInfo;
  }

  //#region info icon click in grid---Need refactor
  public infoBoxCartItem: ICartItem;
  public isRowSelected(e: RowArgs) { return false; }
  public openInfoBox(infoBoxCartItem: ICartItem, ev): void {
    this.mySelection = [infoBoxCartItem.longItemNumber];
    this.isRowSelected = (e: RowArgs) => {
      return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
    };
    this.infoOpened = true;
    this.infoBoxCartItem = infoBoxCartItem;
  }
  public closeInfoBox(): void {
    this.infoOpened = false;
    this.isRowSelected = (e: RowArgs) => false;
  }
  //#endregion

  //#endregion
  //#region quote details button click events


  removeAllItemsConfirmationDialog: boolean = false;
  deleteQuoteInProgress: boolean = false;
  protected openDeleteQuoteConfirmationBox(): void {
    let isEmpty: boolean;
    if (this.quoteService.kdQuoteItems) {
      this.quoteService.kdQuoteItems.length === 0 ? isEmpty = true : isEmpty = false;
    }
    if (isEmpty) {
      this.appNotify.notify(NotifyType.ERROR, `There's nothing to remove.`);

    } else {
      this.removeAllItemsConfirmationDialog = true;
    }
  }
  public closeDeleteQuoteConfirmationBox() {
    this.removeAllItemsConfirmationDialog = false;
  }
  deleteAllQuoteItems(): void {
    this.closeDeleteQuoteConfirmationBox();
    this.deleteQuoteInProgress = true;
    const body: IEmptyQuoteItemsBody = {
      quoteCommonId: this.selectedQuoteHeader.quoteCommonId
    }
    this.quoteService.emptyKdQuoteItems(body).subscribe((deletedQuote) => {
      if (deletedQuote) {
        this.appNotify.notify(NotifyType.SUCCESS, "Your Quote is empty now.");
        this.quoteService.kdQuoteItems = [];
        this.loadKdQuoteItemssGrid();
      } else {
        this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
      }
      this.deleteQuoteInProgress = false;

    }, error => {
      this.deleteQuoteInProgress = false;
      this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  addQuoteItemToCart(dataItem: IQuoteItem): void {
    console.log(dataItem);
    const body: IAddQuoteItemToCartItemListBody = {
      quoteItemCommonId: dataItem.quoteItemCommonId,
      //quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId,
      itemType: dataItem.itemType
    }
    this.quoteItemGridLoading = true;
    dataItem.updateInProgress = true;
    this.quoteService.addQuoteItemToCartItemList(body).subscribe((response) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (response) {
        if (response.existingInCartConfigItem) {
          // (start) Afsana K50-1071 edited the wordings for the alertMessage
          this.alertMessage = "The following item(s) already exist in the cart: " + response.existingInCartConfigItem
            + " If you wish to change the quantity, please remove the cart item, update item quantity in the quote, then add back to cart or use express checkout.";
          // (end) Afsana K50-1071 to edited the wordings for the alertMessage
          this.existingQuoteItemInCartAlertBox = true;
        }
        else {
          this.cartService.totalCartItem.next(response.totalCartItemCount);
          this.appNotify.notify(NotifyType.SUCCESS, "Quote Item is added to Cart.");
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        }
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
      this.quoteItemGridLoading = false;
      dataItem.updateInProgress = false;
    }, error => {
      this.infoMessage.genericInProgress = "Sorry! an Error Occured!. Please refresh the page and try again";
      this.saveInProcess = false;
      this.quoteItemGridLoading = false;
      dataItem.updateInProgress = false;
    })
  }
  addQuoteToCart(): void {
    const body: IAddQuoteToCartBody = {
      //jobName: this.quoteService.selectedQuoteHeader.jobName,
      quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId,
      //userId: this.loggedInUser.userId
    }
    //this.quoteItemGridLoading = true;
    this.isQuoteToCartLoading = true;
    this.quoteService.addQuoteToCart(body).subscribe((response: any) => {
      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      this.isQuoteToCartLoading = false;
      if (response) {
        if (response.existingInCartConfigItems && response.existingInCartConfigItems.length > 0) {
          // (start) Afsana K50-1071 edited the wordings for the alertMessage
          this.alertMessage = "The following item(s) already exist in the cart: " + response.existingInCartConfigItems.join(", ")
            + " If you wish to change the quantity, please remove the cart item, update item quantity in the quote, then add back to cart or use express checkout.";
          // (end) Afsana K50-1071 edited the wordings for the alertMessage
          this.existingQuoteItemInCartAlertBox = true;
        }
        const cartCount = this.cartService.totalCartItem.value;
        if (cartCount != response.totalCartItemCount) {
          this.cartService.totalCartItem.next(response.totalCartItemCount);
          this.appNotify.notify(NotifyType.SUCCESS, "Quote has been added to Cart.");
          this.infoMessage.genericSuccess = this.infoMessage.successMessage;
        }
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;

      }
      //this.quoteItemGridLoading = false;

    }, error => {
      this.infoMessage.genericInProgress = "Sorry! an Error Occured!. Please refresh the page and try again";
      this.saveInProcess = false;
      this.isQuoteToCartLoading = false;
    }
    )

  }

  createNewRevision(): void {
    const body: ICreateQuoteItemRevisionBody = {
      quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId,
      jobName: this.quoteService.selectedQuoteHeader.jobName,
      jobNumber: this.quoteService.selectedQuoteHeader.jobNumber,
      marketSegment: this.quoteService.selectedQuoteHeader.marketSegment,
      leed: this.quoteService.selectedQuoteHeader.leed,
      revision: this.quoteService.selectedQuoteHeader.revision,
      //userId: this.loggedInUser.userId,
      customerNumber: this.loggedInUser.customerNumber
    }
    this.isCreateNewRevisionLoading = true;
    this.quoteService.createQuoteItemRevision(body).subscribe((quote) => {

      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (quote) {
        this.appNotify.notify(NotifyType.SUCCESS, "Quote is created with new Revision");
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
      } else {
        this.appNotify.notify(NotifyType.ERROR, 'An Error Occured');
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
      this.loadKdQuoteItemssGrid();
      this.quoteItemGridLoading = false;
      this.quoteService.selectedQuoteHeader = quote;
      quote.jobNumberRevision = quote.jobNumber + '-' + quote.revision;
      quote.marketSegmentObj = { name: quote.marketSegment, value: quote.marketSegment, checked: false };
      Object.assign(this.quoteService.copyQuoteHeader, this.quoteService.selectedQuoteHeader);
      // this.router.navigate(['../'], { relativeTo: this.route });
      this.isCreateNewRevisionLoading = false;

    }, error => {
      this.isCreateNewRevisionLoading = false;
      this.quoteItemGridLoading = false;
      this.infoMessage.genericInProgress = "Sorry! an Error Occured!. Please refresh the page and try again";
      this.saveInProcess = false;
    });
  }
  printMaterialProposal() {
    this.isPrintMaterialProposalLoading = true;
    const body: IPrintMaterialProposalBody = {
      quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId,
      contactFullName: "",
      contactEmail: "",
      userName: this.userService.readUserObject.userName
    }
    this.quoteService.printMaterialProposal(body).subscribe((response: any) => {
      if (response) {
        const linkSource = 'data:application/pdf;base64,' + response.urlPath;
        const downloadLink = document.createElement("a");
        const fileName = body.quoteCommonId + ".pdf";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
      this.isPrintMaterialProposalLoading = false;
    });

  }
  //#region - Excel Upload
  public importDialog = {
    opened: false,
    dataSaved: false,
    showInfo: false,
    isSuccess: false,
    isError: false,
    successMessage: '',
    errorMessage: ' ',
    fileupload: {},
    mode: "import-to-quote"
  };
  openImportDialog() {
    this.importDialog.opened = true;;
  }
  importCompleteEvent($event) {
    this.importDialog = $event;
    if (this.importDialog.dataSaved) {
      this.quoteItemGridLoading = true;
      const body: IGetKdQuoteDetailBody = {
        quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId
      }
      this.quoteService.getKdQuoteDetail(body).subscribe((quoteItems) => {
        //this.setCurrentSizeProperty(quoteItems);
        this.loadKdQuoteItemssGrid()
        this.quoteItemGridLoading = false;
      }, error => {
        this.quoteItemGridLoading = false;
      });

    }
  }
  //#endregion

  //#region copy quote

  get f() {
    return this.copyQuoteForm.controls
  }

  protected copyQuoteDialog = {
    opened: false,
    jobNameLbl: "Job Name",
    marketSegmentLbl: "Market Segment",
    leedLbl: "LEED",
    isSubmitted: false,
    isInvalidManageSegment: false,
    isInvalidJobName: false
  }
  getMarketSegment: IMasterData[];
  toggleCopyQuoteDialog() {
    if (this.quoteService.kdQuoteItems.length > 0) {
      this.copyQuoteDialog.opened = !this.copyQuoteDialog.opened;
      this.infoMessage = new Info();
      this.saveInProcess = false;
      this.copyQuoteForm.reset();
      this.copyQuoteDialog.isInvalidJobName = false;
      this.copyQuoteDialog.isInvalidManageSegment = false;
      this.copyQuoteDialog.isSubmitted = false;
      if (!this.getMarketSegment) {
        this.quoteService.requestAQuotePayload().subscribe((response) => {
          if (response) {
            this.getMarketSegment = response.marketSegments.filter(m => m.name != 'Other Buildings');
          }
        })
      }
    }
    else {
      alert("Atleast one item is required to copy the quote");
    }
  }
  protected validateAddQuoteForm(): boolean {
    let isValid = true;
    if (!this.copyQuoteDialog) {
      return;
    }
    if (this.copyQuoteDialog.isSubmitted) {
      if (this.f.jobName.value) {
        this.copyQuoteDialog.isInvalidJobName = false;
      } else {
        this.copyQuoteDialog.isInvalidJobName = true;
        isValid = false;
      }
      if (this.f.marketSegment.value) {
        this.copyQuoteDialog.isInvalidManageSegment = false;
      } else {
        this.copyQuoteDialog.isInvalidManageSegment = true;
        isValid = false;
      }

    }
    return isValid;
  }
  public selectedGridRow(dataItem) {
    this.mySelection = [dataItem.longItemNumber];
    this.isRowSelected = (e: RowArgs) => {
      return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
    };
  }
  public saveCopyQuoteData() {
    this.copyQuoteDialog.isSubmitted = true;
    if (!this.validateAddQuoteForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.inProgressMessage;
    console.log(this.copyQuoteForm.controls)
    if (this.copyQuoteForm.value.leed == null) {
      this.copyQuoteForm.value.leed = false;
    }
    const controls = this.copyQuoteForm.controls;
    const body: ICopyQuoteRequestBody = {
      jobName: controls.jobName.value,
      marketSegment: controls.marketSegment.value ? controls.marketSegment.value.name : "",
      marketSegmentId: controls.marketSegment.value ? controls.marketSegment.value.value : "",
      leed: this.copyQuoteForm.value.leed as boolean,
      quoteCommonId: this.quoteService.selectedQuoteHeader.quoteCommonId,
      customerNumber: this.loggedInUser.customerNumber,
      //userId: this.loggedInUser.userId
    }
    this.quoteItemGridLoading = true;
    this.quoteService.copyKdQuote(body).subscribe((quote: IQuote) => {

      this.infoMessage.genericInProgress = "";
      this.saveInProcess = false;
      if (quote) {
        this.infoMessage.genericSuccess = this.infoMessage.successMessage;
      } else {
        this.infoMessage.genericError = this.infoMessage.errorMessage;
      }
      this.loadKdQuoteItemssGrid();
      this.copyQuoteForm.reset();
      this.quoteItemGridLoading = false;
      //quote.jobNumberRevision = quote.jobNumber + "-" + quote.revision;      
      this.quoteService.selectedQuoteHeader = quote;
      quote.jobNumberRevision = quote.jobNumber + '-' + quote.revision;
      quote.marketSegmentObj = { name: quote.marketSegment, value: quote.marketSegment, checked: false };
      Object.assign(this.quoteService.copyQuoteHeader, this.quoteService.selectedQuoteHeader);
      //this.router.navigate(['../'], { relativeTo: this.route });
    }, error => {
      this.infoMessage.genericInProgress = "Sorry! an Error Occured!. Please refresh the page and try again";
      this.saveInProcess = false;
      this.quoteItemGridLoading = false;
    })
  }
  //#endregion
  setCurrentSizeProperty(quoteItems: QuoteItem[]) {
    this.isEmptyPaintInGrid = false;
    this.isHaveErrorInGrid = false;
    this.quoteService.KD_Quote_Has_Error = false;
    quoteItems.forEach(x => {
      if (x.availableFinishes)
        var tempfinish = x.availableFinishes.find(y => y.value === x.finishValue);
      if (x.itemType == 1 && x.finishValue && !tempfinish) {
        this.isHaveErrorInGrid = true;
        this.quoteService.KD_Quote_Has_Error = true;
      }
      if (x.doesHaveError) {
        this.isHaveErrorInGrid = true;
        this.quoteService.KD_Quote_Has_Error = true;
      }
      if (tempfinish) {
        x.currentSizes = tempfinish.availableSizes;
        if (tempfinish.value == "22" && (x.paint == '' || x.paint == null)) {
          this.isEmptyPaintInGrid = true;
          this.quoteService.KD_Quote_Has_Error = true;
          x.isEmptyPaint = true;
        }
      }

    });
  }
  itemAdded(quoteItem) {

    console.log(quoteItem);

    if (quoteItem) {
      if (quoteItem.mode === 'UPDATE') {
        let temp = this.quoteService.kdQuoteItems.find(x => (x.longItemNumber === quoteItem.longItemNumber && x.paint === quoteItem.paint));
        if (temp) {
          temp.quantity = (+quoteItem.quantity);// + (+temp.quantity);
          temp.extendedPrice = quoteItem.extendedPrice;
        }
      } else if (quoteItem.mode === 'ADD') {
        this.quoteService.kdQuoteItems.push(quoteItem);
      }

      this.loadKdQuoteItemssGrid()
    }
  }
  showImageBox: boolean = false;
  selectedItem: any = clone({});
  public showImageModal(item: IQuoteItem, ev): void {
    this.selectedItem = item;
    if (this.selectedItem.itemType === 1) {
      this.showImageBox = true;
      this.mySelection = [this.selectedItem.longItemNumber];
      this.isRowSelected = (e: RowArgs) => {
        return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
      };
      const objectURL = environment.imageBaseUrl + environment.imageFolder + this.selectedItem.itemNumber + "_S.gif";
      this.selectedItem.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);;

    } else if (this.selectedItem.itemType === 2) {
      this.showImageBox = true;
      this.mySelection = [this.selectedItem.quoteItemCommonId];
      this.isRowSelected = (e: RowArgs) => {
        return this.mySelection.indexOf(e.dataItem.quoteItemCommonId) >= 0;
      };
      this.getProductImage(this.selectedItem.quoteItemCommonId);
    }
  }
  public closeImageModal(): void {
    this.showImageBox = false;
    this.selectedItem = clone({});
    this.isRowSelected = (e: RowArgs) => false;
  }
  //public showPagging(pageable: boolean) {
  //  this.pageable = pageable;
  //  if (this.pageable) {
  //    this.gridHeight = '';
  //  }
  //  else {
  //    this.gridHeight = '570';
  //  }
  //}
  getProductImage(quoteItemCommonId: string) {
    const data = {
      quoteItemCommonId: quoteItemCommonId,
      width: 150,
      height: 150,
    }
    this.productService.getThumbnailImage(data).subscribe(resp => {
      let objectURL = 'data:image/jpeg;base64,' + resp;
      this.selectedItem.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
    })
  }
  navigateToCopyConfigProduct(item: IQuoteItem) {
    this.v6productService.copyProductConfigInQuote(item);
    let routepath = '/manage-quote/kawneerdirect-quotes/copyConfiguredProduct/' + item.quoteItemCommonId;
    this.router.navigate([routepath]);

  }
  navigateToEditConfigProduct(item: IQuoteItem) {
    this.v6productService.editProductConfigInQuote(item);
    let routepath = '/manage-quote/kawneerdirect-quotes/editConfiguredProduct/' + item.quoteItemCommonId;
    this.router.navigate([routepath]);
  }

  closeQuoteItemInCartAlertBox() {
    this.existingQuoteItemInCartAlertBox = false;
  }
  onJobNameInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleanedValue = this.cleanFormatting(input.value);
    input.value = cleanedValue;
    this.orderdetail.jobName = cleanedValue;
  }
  onPoInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const cleanedValue = this.cleanFormatting(input.value);
    input.value = cleanedValue;
    this.orderdetail.po = cleanedValue;
  }
  onJobNameChange(value: Event) {
    const cleaned = value.target as HTMLInputElement;
    cleaned.value = this.cleanFormatting(cleaned.value);
    this.orderdetail.jobName = cleaned.value;
  }
  onPoNameChange(value: Event) {
    const cleaned = value.target as HTMLInputElement;
    cleaned.value = this.cleanFormatting(cleaned.value);
    this.orderdetail.po = cleaned.value;
  }
  private cleanFormatting(text: string): string {
    // Replace long dash with regular dash
    // Replace italic apostrophes with standard apostrophe
    return text
      .replace(/\u2013|\u2014/g, "-")
      .replace(/′/g, "'")
      .replace(/‘|’/g, "'")
      .replace(/\u0152/g, "OE")   // Œ
      .replace(/\u0153/g, "oe")   // œ
      .replace(/\u0178/g, "Y");   // Ÿ
  }


  public showImagePWA(item): string {
    // this.pageable = false;
    //this.selectedItem = item;
    if (item.itemType === 1) {
      //this.showImageBox = true;
      // this.mySelection = [this.selectedItem.longItemNumber];
      //this.isRowSelected = (e: RowArgs) => {
      //  return this.mySelection.indexOf(e.dataItem.longItemNumber) >= 0;
      //};
      const objectURL = environment.imageBaseUrl + environment.imageFolder + item.itemNumber + "_S.gif";
      item.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      //return objectURL;


    } else if (item.itemType === 2) {
      //this.showImageBox = true;
      //this.mySelection = [this.selectedItem.cartItemCommonId];
      //this.isRowSelected = (e: RowArgs) => {
      //  return this.mySelection.indexOf(e.dataItem.cartItemCommonId) >= 0;
      //};
      const data = {
        quoteItemCommonId: item.quoteItemCommonId,
        width: 150,
        height: 150,
      }
      this.productService.getThumbnailImage(data).subscribe(resp => {
        let objectURL = 'data:image/jpeg;base64,' + resp;
        item.thumbnail = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        // return objectURL;
      })
    }
    item.funcCall = 1;
    return item.funcCall;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }


  //#region Express Checkout
  //#region Language Translation
  expressCheckoutControlTexts: ICheckOutOrderDetailsLbl;
  lblText: ICheckOutLabel;
  initTranslationForExpressCheckout() {
    const controlNameList = [
      { controlName: "commentsLbl1" },
      { controlName: "commentsLbl2" },
      { controlName: "confirmEmailLbl" },
      { controlName: "invalidConfirmEmail" },
      { controlName: "frieghtTermsLbl" },
      { controlName: "inputTax" },
      { controlName: "jobNameLbl" },
      { controlName: "jobCityLbl" },
      { controlName: "jobStateLbl" },
      { controlName: "leedLbl" },
      { controlName: "stateLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "poLbl" },
      { controlName: "quotedInHouseLbl" },
      { controlName: "quoteNumberLbl" },
      { controlName: "requestDateLbl" },
      { controlName: "taxableCertificationLbl" },
      { controlName: "characterRemainingLbl" },
      //{ controlName: "promoCodeLbl" },
      { controlName: "promoApplyLbl" },
      { controlName: "promoNotValidLbl" },
      { controlName: "promoValidLbl" },
      { controlName: "defaultCreditInfoLbl" },
      { controlName: "toModifyCreditLbl" },
      { controlName: "payByCreditLbl" },
      { controlName: "cardTypeLbl" },
      { controlName: "nameOnCardLbl" },
      { controlName: "creditCardNumberLbl" },
      { controlName: "cardExpiryLbl" },
      { controlName: "totalPriceLabel" },
      { controlName: "taxablebuttonlbl" },
      { controlName: "taxabletitlelbl" },
      { controlName: "taxCertifiacteddlheadertxt" },
      { controlName: "taxCertifiactetitletxt" },
      { controlName: "taxCertifiactebtntxt" },
      { controlName: "taxCertifiactenotelbl" },
      { controlName: "frieghtTermsEstLbl" },
      { controlName: "frieghtTermsEstMsgLbl" },
      { controlName: "frieghtTermsPickupLbl" },
      { controlName: "frieghtTermsCollectLbl" },
      { controlName: "frieghtTermsPickupMsgLbl" },
      { controlName: "frieghtTermsPrePaidLbl" },
      { controlName: "frieghtTermsPrePaidText" },
      { controlName: "includeFreightTitlelbl" }, 
    ];
    const componentName = "checkout-order-details";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.expressCheckoutControlTexts = response[response.length - 1];
    }

    const statusControlNameList = [
      { controlName: "currentBillingAddressLbl" },
      { controlName: "currentShippingAddressLbl" },
      { controlName: "orderDetailsLbl" },
      { controlName: "paymentLbl" },
      { controlName: "reviewOrderLbl" },
      { controlName: "shippingLbl" },
      { controlName: "continueLbl" },
      { controlName: "confirmOrderLbl" },
      { controlName: "submitedInfo1" },
      { controlName: "submitedInfo2" },
      { controlName: "submitedInfo3" },
      { controlName: "submitedInfo4" },
      { controlName: "continueShoppingLbl" },
      { controlName: "kawneerOrderLbl" },
      { controlName: "kdLbl" },
      { controlName: "closeLbl" },
      { controlName: "surveyFeedbackLbl" },
      { controlName: "placeOrderChangetoAccountLbl" },
      { controlName: "placeOrderWithCreditCardLbl" }
    ];
    const componentName1 = "checkout";
    const response1 = this.languageTranslationService.getLanguageTranslationList(statusControlNameList, componentName1);//temp hack
    if (response1.length > 0) {
      this.lblText = response1[response.length - 1];
    }
  }
  public creditInfoLabel = {
    defaultCreditInfoLbl: '',
    toModifyCreditLbl: 'If paying by Credit Card, provide in the Comment section the card type and last 4 digits of the card to be charged.',
    payByCreditLbl: 'Pay Order By Credit Card:',
    cardTypeLbl: 'Card Type:',
    cardTypeText: '',
    nameOnCardLbl: 'Name On Card:',
    nameOnCardText: '',
    creditCardNumberLbl: 'Credit Card Number:',
    cardNumberText: '',
    cardExpiryLbl: 'Expiration Month/Year:',
    cardExpiryText: '',
    expirationYear: '',
    expirationMonth: '',
  }

  orderdetailsLbl = {
    jobSearchHeadingLbl: "Job Search",
    jobNumberLbl: 'Job Number',
    jobNameLbl: 'Job Name',
    jobCityLbl: 'Job City',
    jobStateLbl: 'Job State',
    poLbl: 'PO',
    marketSegmentLbl: 'Market Segment',
    frieghtTermsLbl: 'Freight Terms',
    requestDateLbl: 'Request Date',
    confirmEmailLbl: 'Confirm E-Mail Recipients',
    invalidConfirmEmail: "Email address is invalid",
    leedLbl: 'LEED',
    taxableLbl: 'Taxable',
    quotedInHouseLbl: 'Quoted In-House?',
    frightNotesLbl: 'Freight Notes',
    commentsLbl1: 'Comments',
    commentsLbl2: 'Comments for packing and shipping. Comments not to be used to alter order material(s).',
    quoteNumberLbl: 'Quote Number (XXXXXXE-XXX)',
    taxableCertificationLbl: 'Certificate/Registration No.',
    inputTax: 'Enter YourTax Exempt Certificate No/PST Registration No. on file of Ship-To State/Province or upload file.',
    characterRemainingLbl: 'Characters Remaining',
    promoCodeLbl: 'Promo Code?',
    promoApplyLbl: 'Apply',
    promoNotValidLbl: 'is not a valid code',
    promoValidLbl: 'has been verified and will be applied by kawneer during order processing',
    jobSearchBtnLbl: 'Search',
    addJobLbl: 'Add Job',
    taxablebuttonlbl: 'Certificates on file with Kawneer',
    taxabletitlelbl: 'Tax will be calculated at timing of invoicing based on valid State/Province/Project certificates on file with Kawneer',
    taxCertifiacteddlheadertxt: 'Active Certificates on File with Kawneer',
    taxCertifiactetitletxt: 'Tax Certificates',
    taxCertifiactebtntxt: 'Add Selected Certificate to Order Comments',
    taxCertifiactenotelbl: 'Please contact your customer service team to add or update certificates. Allow 24-48 hours for processing. Orders may be submitted while certificates are being processed. If you have a certificate that is processing with our team, be sure to include the certificate number in the order comments. Tax status will be verified against active certificates prior to invoicing.',
    frieghtTermsPrePaidLbl: 'Prepaid',
    frieghtTermsEstLbl: 'Estimate & include with order*',
    frieghtTermsEstMsgLbl: '*Shipping cost is estimated and subject to change at time of order entry',
    frieghtTermsPickupLbl: 'Pickup**',
    frieghtTermsCollectLbl: 'Collect',
    frieghtTermsPickupMsgLbl: '** Shipping costs may still be applicable for pickup orders depending upon the products originating location',
    frieghtTermsPrePaidText: 'Calculated & added to invoice at time of shipment',
    includeFreightLbl: 'Include Freight',
    includeFreightTitlelbl: 'Select “Yes” to generate freight costs for the products in your cart and include the freight cost in your order acknowledgement.  Select “No” if you receive an error message or if you would prefer to receive your freight costs only at invoicing.'
  }
  protected checkOut = {
    confirmOrderToPlaceOrder: false,
    currentBillingAddressLbl: 'Current Billing Address:',
    currentBillingAddressValue1: '2762-ROYAL GLASS CO INC',
    currentBillingAddressValue2: '3200 DE LA CRUZ BLVD.',
    currentBillingAddressValue3: 'SANTA CLARA, CA 95054',
    currentShippingAddressLbl: 'Current Shipping Address:',
    currentShippingAddressValue1: '2762-ROYAL GLASS CO INC',
    currentShippingAddressValue2a: '3200 DE LA CRUZ BLVD.',
    currentShippingAddressValue3: 'SANTA CLARA, CA 95054',
    shippingLbl: "Shipping",
    continueLbl: 'Continue',
    orderDetailsLbl: 'Order Details',
    reviewOrderLbl: "REVIEW & PLACE ORDER",
    confirmOrderLbl: 'Confirm Order',
    submitedInfo1: 'Thank you for shopping with us.',
    submitedInfo2: 'Your order has been successfully placed.',
    continueShoppingLbl: 'Continue Shopping!',
    kawneerOrderLbl: 'Your KawneerDirect Order Number',
    kdLbl: 'KD',
    submitedInfo3: 'Sorry we are unable to process your order. Please try again.',
    submitedInfo4: 'If problem persists, please connect to Kawneer Admin',
    closeLbl: 'Close',
    surveyFeedbackLbl: 'Take Survey',
    placeOrderChangetoAccountLbl: 'Place Order - Charge to Account',
    placeOrderWithCreditCardLbl: 'Place Order - Pay with Credit Card',
  };

  //#endregion
  showCheckoutModal: boolean = false;
  stateList: IState[];
  marketSegments: { name: string, value: string, checked: boolean }[] = [];
  freightTerms: IDropDownData;
  expressCheckoutForm: FormGroup;
  checkOutProcessModel: ICheckOutProcessModel = new CheckOutProcessModel();
  _orderDetailsForm: IOrderDetailsFormValidate = new OrderDetailsFormValidate(); //;//to be refactored
  minRequestDate: Date;// = new Date();
  maxRequestDate: Date;
  public sizes: Array<string> = [];
  isEmailFormatInvalid: boolean = false;//change name to isEmailFormatValid
  defaultTaxItem: IDropDownData = { text: 'Select value', value: 'DEFAULT' };
  public taxableDropdownData: IDropDownData[] = [{ text: "Yes", value: "YES" }, { text: "No", value: "NO" }];
  taxHelpInfo: boolean = false;
  @ViewChild('taxableInfo', { static: false }) public anchor: ElementRef;
  public inputTax: string;
  fileToUpload: File = null;
  taxFiles: Array<FileInfo> = [];
  headerJobName: string = "";
  headerJobNumber: string = "";
  headerOrderTotal: number = 0;
  currentShipping: Customer;
  commentslength: number = 0;
  maxChars = 120;
  addressSearchString: string = '';
  curShipToName: string = 'xxx';
  kdRefNumber: string = '';
  //#region Properties
  protected get getFreightTerms$(): Observable<IMasterData[]> {
    return this.masterDataService.getFreightTerms$;
  }
  public get dynamicHeight() {
    return this.sizes.length ? 0 : 0;
  }
  protected get orderdetail(): IOrderDetail {
    if (!this.checkOutProcessModel) { this.initExpressCheckoutModel(); }
    return this.checkOutProcessModel.orderDetail;
  }
  protected get orderDetailsForm() {
    return this._orderDetailsForm;
  }

  protected set orderDetailsForm(value) {
    this._orderDetailsForm = value;
  }
  protected get getjobState$(): IState[] {
    return this.masterDataService.allStatesOfUsAndCanada;
  }
  //#endregion
  async initExpressCheckoutModel() {
    /*
    1. Based on current user fetch, preferred shipping address
    2. User can search and change the shipping address
    3. Load default values such as job name, leed, market segment from the quote itself
    4. Fill up rest of the required order details fields(input from user)
    5. Show progress msg once user hits confirm checkout
    6. Show KD Ref num once order is successfull, error message if checkout fails
    7. ***Do not allow user to close the  modal when cehckout is in progress
    8. User should not be able to make any update when checkout is in progress
    */
    this.checkOutProcessModel = new CheckOutProcessModel();
    this.showAddressSearch = false;
    this.kdRefNumber = '';
    //if checkout is already in progress then we have to handle that
    this.isConfirmCheckoutBtnClicked = false;
    this.showErrorIndicatorToUser = false;
    this.checkoutNotStarted = true;
    this.checkoutSuccess = false;
    this.checkoutError = false;
    this.shouldShowMaxShipToSearchHelpText = false;
    //set shipping address
    this.currentShipping = new Customer();
    await this.initAddressList();
    await this.initMarketSegmentList();
    this.initOtherCheckoutDropdownData();
    //set order details
    console.log(this.quoteService.selectedQuoteHeader);
    this.orderdetail.jobName = this.headerJobName = this.quoteService.selectedQuoteHeader.jobName;
    this.headerJobNumber = this.quoteService.selectedQuoteHeader.jobNumber;
    this.headerOrderTotal = this.checkOutProcessModel.orderTotal = this.quoteItemsTotal;
    let m = this.marketSegments.find(x => x.name == this.quoteService.selectedQuoteHeader.marketSegmentObj.name);
    let mktSegmnet = m;
    //mktSegmnet.name = "";//this.quoteService.selectedQuoteHeader.marketseg...
    //mktSegmnet.value = "";
    this.orderdetail.marketSegment = m;// this.quoteService.selectedQuoteHeader.marketSegmentObj;
    this.orderdetail.leed = this.quoteService.selectedQuoteHeader.leed;
    this.initCreditCardSection();

    //set item total if required
  }
  async initAddressList() {
    await this.customerService.getAllAddressList().pipe(tap((customers: ICustomer[]) => {
      this.customerService.addressList = customers as ICustomer[];
    })).subscribe((customers: ICustomer[]) => {
      this.initShippingAddress();
      this.initBillingAddress();
    });
  }
  async initMarketSegmentList() {
    this.masterDataService.getMarketSegments().then(r => {
      r.forEach((m: any) => {
        this.marketSegments.push({ name: m.name, value: m.value, checked: false });
      });
    });
  }
  async initOtherCheckoutDropdownData() {
    this.masterDataService.GetAllSupportDataForCheckOutOrderDetail().pipe(
      tap((response: IGetAllSupportDataForCheckOutOrderDetail) => {
        this.masterDataService.countries = response.countries as ICountry[];
        this.masterDataService.allStatesOfUsAndCanada = [...response.countries[0].states, ...response.countries[1].states];//]push(response.countries[0].states as IState);
        this.masterDataService.freightTerms = response.freightTerms as IMasterData[];
      })
    ).subscribe((response: IGetAllSupportDataForCheckOutOrderDetail) => {
      this.stateList = this.masterDataService.allStatesOfUsAndCanada;
    });
  }

  initShippingAddress() {
    let defaultAddress = this.customerService.getAddressList.find(x => x.isDefault);
    if (defaultAddress) {
      this.currentShipping = this.checkOutProcessModel.currentShipping = defaultAddress;
      this.checkoutService.checkOutProcessModel.shipToCustomerNumber = defaultAddress.customerNumber;
      this.setSelectedShipToAddressForDisplay(defaultAddress);
    }
    else {
      let activeAddress = this.customerService.getAddressList.find(x => x.isActive);//ensure it is ship to address
      if (activeAddress) {
        this.currentShipping = this.checkOutProcessModel.currentShipping = activeAddress;
        this.checkoutService.checkOutProcessModel.shipToCustomerNumber = activeAddress.customerNumber;
        this.setSelectedShipToAddressForDisplay(activeAddress);
      }
    }
  }
  initBillingAddress() {
    //set billing address
    const currentBillingAddress = this.customerService.getAddressList
      .find(r => (r.billingType === AddressType.Both || r.billingType == AddressType.Billing) && r.isActive && r.customerNumber === +this.userService.readUserObject.customerNumber)
    if (currentBillingAddress) {
      this.checkOutProcessModel.currentBilling = currentBillingAddress;
      this.checkOutProcessModel.billToCustomerNumber = currentBillingAddress.customerNumber;
    }
  }

  validateForm() {

  }
  jobSearchIconClick() {

  }
  toggleJobSearchSection() {

  }
  jobStateChange() { }
  handleStatesFilterChange(value) {
    this.stateList = this.getjobState$.filter((s) => s.stateDescription.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
  marketSegmentChange(event) { }
  freightTermsChange(event) { }

  checkConfirmEmail(value) {
    var isValidEmail = true;
    if (value) {
      if (value.length > 0) {
        for (var i = 0; i < value.length; i++) {
          const res = this.helperService.validateEmail((value[i]).toLowerCase());
          if (!res) {
            isValidEmail = false;
          }
        }
        if (!isValidEmail) {
          this.isEmailFormatInvalid = true;
          this.orderDetailsForm.isInvalidConfirmEmail = true;
        } else {
          this.isEmailFormatInvalid = false;
          this.orderDetailsForm.isInvalidConfirmEmail = false;
        }
      } else {
        this.isEmailFormatInvalid = false;
        this.orderDetailsForm.isInvalidConfirmEmail = false;
      }
    }
  }
  public checkRequestDate() {
    if (this.orderdetail.requestDate) {
      if (this.orderdetail.requestDate < this.minRequestDate || this.orderdetail.requestDate > this.maxRequestDate) {
        this.orderDetailsForm.isInvalidRequestDate = true;
      } else {
        this.orderDetailsForm.isInvalidRequestDate = false;
      }
    } else {
      this.orderDetailsForm.isInvalidRequestDate = false;
    }
  }
  taxableChange(event) {
    this.orderdetail.taxable = event.value;
    if (this.orderdetail.taxable != 'NO') {
      this.taxFiles = [];
      this.orderdetail.taxFileName = '';
      this.orderdetail.taxFileName = '';
    }
  }
  taxableInfoToggle() {
    this.taxHelpInfo = !this.taxHelpInfo;
  }
  //#region Tax Doc Upload

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }
  fileSelected(evt) {
    this.orderdetail.taxFileName = evt.files[0].name;
  }
  uploadSuccess(evt: SuccessEvent) {
    this.orderdetail.taxFile = evt.response.body.paths[0];
  }
  uploadComplete() {

  }
  uploadRemove(evt: RemoveEvent) {
    this.orderdetail.taxFileName = '';
    this.orderdetail.taxFileName = '';
  }
  //#endregion
  commenttxtArea(event) {
    this.commentslength = event.target.value.length;
  }
  showExpressCheckoutModal() {
    if (this.quoteService.kdQuoteItems.length === 0) {
      alert("Atleast one item is required to copy the quote");
      return;
    }
    this.initTranslationForExpressCheckout();
    this.initExpressCheckoutModel();
    this.minRequestDate = new Date();
    this.maxRequestDate = new Date(this.minRequestDate.getFullYear() + 1,
      this.minRequestDate.getMonth(),
      this.minRequestDate.getDate());
    this.inputTax = 'Enter YourTax Exempt Certificate No/PST Registration No. on file of Ship-To State/Province or upload file.';
    this.orderDetailsForm = new OrderDetailsFormValidate();
    if (this.checkoutService.checkOutProcessModel && this.checkoutService.checkOutProcessModel.freightAmount) {
      this.checkoutService.checkOutProcessModel.freightAmount = 0;
    }
    this.showCheckoutModal = true;
  }
  closeExpressCheckoutModal() {
    this.showCheckoutModal = false;
    if (this.checkoutService.checkOutProcessModel && this.checkoutService.checkOutProcessModel.freightAmount) {
      this.checkoutService.checkOutProcessModel.freightAmount = 0;
    }
  }
  //#region Address serach section
  showAddressSearch: boolean = false;
  suggestedAddressList: Customer[] = [];

  showAddressSearchSection() {
    this.showAddressSearch = true;
  }
  hideAddressSearchSection() {
    this.showAddressSearch = false;
  }
  customerAddressLine1: string = "";
  customerAddressLine2: string = "";
  customerAddressLine3: string = "";
  setSelectedShipToAddressForDisplay(address: ICustomer) {
    this.customerAddressLine1 = address.customerNumber + " - " + address.customerName;
    this.customerAddressLine2 = address.addressLine1 + " " + address.addressLine2;
    this.customerAddressLine3 = address.city + "," + address.state + " " + address.zipCode;

  }

  changeShippingAddress(customerNumber) {
    console.log("cust num");
    console.log("cust num", customerNumber);
    this.curShipToName = customerNumber;
    let address = this.customerService.getAddressList.find(x => x.customerNumber == customerNumber);
    if (address) {
      this.checkOutProcessModel.currentShipping = address;
      this.curShipToName = address.customerName;
      this.setSelectedShipToAddressForDisplay(address);
      if (this.checkoutService.prepaidFreightSelected) {
        this.calculateFreightAmount();
      }
    }


  }
  isNumeric(value) {
    return /^-?\d+$/.test(value);
  }
  maxShipToResultCount: number = 5;
  shouldShowMaxShipToSearchHelpText: boolean = false;
  searchAddress() {
    //console.log(this.addressSearchString);
    let searchString = this.addressSearchString.trim().toLowerCase();
    this.shouldShowMaxShipToSearchHelpText = false;
    this.suggestedAddressList = [];
    let filteredList: Customer[] = [];
    if (this.isNumeric(searchString)) {

      //search by zipcode
      filteredList = this.customerService.getAddressList.filter(x => x.isActive && x.zipCode.indexOf(searchString) > -1);

    }
    else {
      //search by name
      filteredList = this.customerService.getAddressList.filter(x => x.isActive
        && (x.customerName.indexOf(searchString) > -1
          || x.addressLine1.indexOf(searchString) > -1));

    }
    if (filteredList) {
      if (filteredList.length > this.maxShipToResultCount) {
        this.suggestedAddressList = filteredList.slice(0, this.maxShipToResultCount);
        this.shouldShowMaxShipToSearchHelpText = true;
      }
      else {
        this.suggestedAddressList = filteredList;
      }
    }
  }
  //#endregion

  checkoutNotStarted: boolean = true;
  checkoutInProgress: boolean = false;
  checkoutSuccess: boolean = false;
  checkoutError: boolean = false;
  isConfirmCheckoutBtnClicked: boolean = false;
  showErrorIndicatorToUser: boolean = false;
  public validateCheckoutDetails(ccOrder: boolean) {
    if (this.isConfirmCheckoutBtnClicked) {
      this.showErrorIndicatorToUser = true;
      this.orderDetailsForm.isSubmitted = true;
    }
    else {
      this.showErrorIndicatorToUser = false;
      this.orderDetailsForm.isSubmitted = false;
    }

    let isvalid = true;
    if (!this.checkOutProcessModel) {
      isvalid = false;
      return isvalid;
    }
    if (!this.checkOutProcessModel.orderDetail) {
      isvalid = false;
      return isvalid;
    }
    //if ship to or bill to null then return false
    this.orderDetailsForm.isInvalidJobName = this.checkOutProcessModel.orderDetail.jobName ? false : true;
    this.orderDetailsForm.isInvalidPO = this.checkOutProcessModel.orderDetail.po ? false : true;
    this.orderDetailsForm.isInvalidJobCity = this.checkOutProcessModel.orderDetail.jobCity ? false : true;
    const isStateSelected = this.checkOutProcessModel.orderDetail.jobState ? this.checkOutProcessModel.orderDetail.jobState.stateCode : "";
    this.orderDetailsForm.isInvalidJobState = isStateSelected ? false : true;
    this.orderDetailsForm.isInvalidMarketSegment = this.checkOutProcessModel.orderDetail.marketSegment ? false : true;
    this.orderDetailsForm.isInvalidComments = this.checkOutProcessModel.orderDetail.comments && this.checkOutProcessModel.orderDetail.comments.length > 120 ? true : false;
    this.orderDetailsForm.isInvalidFreightTerms = this.checkOutProcessModel.orderDetail.freightTerms ? false : true;
    //if (ccOrder) {
    //  this.orderDetailsForm.isInvalidFreightTerms = false;
    //  if (!this.checkoutService.prepaidFreightSelected) {
    //    this.orderDetailsForm.isInvalidFreightTerms = true;
    //  }
    //  else if (this.checkoutService.prepaidFreightSelected) {
    //    if (!this.orderDetailsForm.isFreightCalcSuccessfull) {
    //      this.orderDetailsForm.isInvalidFreightTerms = true;
    //    }
    //  }
    //}
    //else {
    //  this.orderDetailsForm.isInvalidFreightTerms = this.checkOutProcessModel.orderDetail.freightTerms ? false : true;
    //}
    this.orderDetailsForm.isInvalidFreightNotes = false;
    if (this.checkOutProcessModel.orderDetail.freightTerms.value == '4') {
      if (this.checkOutProcessModel.orderDetail.freightNotes) {
        this.orderDetailsForm.isInvalidFreightNotes = false;
      } else {
        this.orderDetailsForm.isInvalidFreightNotes = true;
      }
    }
    this.orderDetailsForm.isInvalidComments = this.checkOutProcessModel.orderDetail.comments && this.checkOutProcessModel.orderDetail.comments.length > 120 ? true : false;
    if (!this.orderDetailsForm.isInvalidJobName
      && !this.orderDetailsForm.isInvalidJobName
      && !this.orderDetailsForm.isInvalidPO
      && !this.orderDetailsForm.isInvalidJobCity
      && !this.orderDetailsForm.isInvalidJobState
      && !this.orderDetailsForm.isInvalidMarketSegment
      && !this.orderDetailsForm.isInvalidFreightTerms
      && !this.orderDetailsForm.isInvalidConfirmEmail
      && !this.orderDetailsForm.isInvalidRequestDate
      && !this.orderDetailsForm.isInvalidComments
      && !this.orderDetailsForm.isInvalidFreightNotes
       ) {
      isvalid = true;

    }
    else { isvalid = false; }
    return isvalid;
  }
  processCheckout() {
    this.isConfirmCheckoutBtnClicked = true;
    this.showErrorIndicatorToUser = true;
    if (!this.validateCheckoutDetails(false)) { return false; }
    this.handleCheckoutInProgress();
    this.checkoutService.expressCheckout(this.checkOutProcessModel, this.selectedQuoteHeader.quoteCommonId).subscribe((response: IBaseResponse) => {

      //hope everything is successfull & order acknoledge number is received.
      if (!response.isError) {
        //this.orderAcknowledgementDialog.opened = true;
        //this.orderAcknowledgementDialog.acknowledgeNumber = response.data.toString(); //assign order acknoledge number from response
        //this.cartService.totalCartItem.next(0);
        //this.orderInProcess = false;
        //this.checkoutService.reset();
        this.kdRefNumber = response.data.toString();
        try {
          this.sendLogToGoogleAnalytics(this.kdRefNumber);
        }
        catch (e) { }
        this.handleCheckoutSuccess();
      } else {
        //this.orderAcknowledgementDialog.opened = true;
        //this.orderAcknowledgementDialog.isError = true;
        //this.orderInProcess = false;
        this.handlecheckoutError();
      }

    });
  }
  //GA implementation 
  sendLogToGoogleAnalytics(kdRefNumber = '') {
    gtag('event', 'Express_Checkout', {
      'event_category': 'Checkout',
      'event_label': 'Express Checkout Clicked',
      'value': kdRefNumber
    })
  }
  handleCheckoutInProgress() {
    this.checkoutNotStarted = false;
    this.checkoutInProgress = true;
    this.checkoutSuccess = false;
    this.checkoutError = false;
  }
  handleCheckoutSuccess() {
    this.checkoutNotStarted = false;
    this.checkoutInProgress = false;
    this.checkoutSuccess = true;
    this.checkoutError = false;
  }
  handlecheckoutError() {
    this.checkoutNotStarted = false;
    this.checkoutInProgress = false;
    this.checkoutSuccess = false;
    this.checkoutError = true;
  }

  //#region Credit Card section
  showCreditSection: boolean = false;
  showCreditCardDetails: boolean = false;
  useCreditCard(selection) {
    if (selection == true) {
      this.showCreditCardDetails = true;
    } else {
      this.showCreditCardDetails = false;
    }
  }
  initCreditCardSection() {
    this.showCreditSection = true;
    //this.userService.getCreditInfo().subscribe((response) => {
    //  this.showCreditSection = true;
    //  if (response.cardNumber) {
    //    this.creditInfoLabel.cardNumberText = response.cardNumber;
    //    this.creditInfoLabel.cardTypeText = response.cardType;
    //    this.creditInfoLabel.nameOnCardText = response.nameOnCard;
    //    this.creditInfoLabel.expirationYear = response.expirationYear;
    //    this.creditInfoLabel.expirationMonth = response.expirationMonth;
    //    this.creditInfoLabel.cardNumberText = response.cardNumber;
    //    if (response.isSavedAsDefault == true) {
    //      this.checkoutService.checkOutProcessModel.orderDetail.useCreditCard = true;
    //      this.showCreditCardDetails = true;
    //    } else {
    //      this.checkoutService.checkOutProcessModel.orderDetail.useCreditCard = false;
    //      this.showCreditCardDetails = false;
    //    }
    //  } else {
    //    this.showCreditSection = false;
    //  }
    //});
  }
  //#endergion

  //#endregion



  taxCertificateForm = new FormGroup({
    taxCertificate: new FormControl(""),
  })
  public async toggletaxCertificatesDialog() {
    this.taxCertificatesDialog.valid = false;
    if (!this.taxCertificatesDialog.opened) {
      const taxResponse = await this.checkoutService.searchtaxCertificate();
      if (!taxResponse.isError) {
        this.filteredTaxCertificatesItems = taxResponse.data;
      }
    }
    this.taxCertificatesDialog.opened = !this.taxCertificatesDialog.opened;
    if (this.taxCertificatesDialog.opened == true) {
      this.taxCertificateForm.reset();
    }
  }
  protected taxCertificatesDialog = {
    opened: false,
    valid: false
  }
  handleTaxCertificateFilter(searchQuery: any) {
    this.filteredTaxCertificatesItems = this.taxertificatesItemsOrg.filter((s) => s.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1);
  }
  onCloseCertificateChange(event) {
    this.filteredTaxCertificatesItems = this.taxertificatesItemsOrg;
  }
  selectedTaxCertificate: any;
  protected taxCertificateChangeSelected(event) {
    this.selectedTaxCertificate = event.name;
    this.taxCertificatesDialog.valid = true;
    // this.changeCustomerDialog = false;
  }
  public addCertificatesCommentSubmit() {
    if (this.orderdetail.comments != undefined && this.orderdetail.comments != '') {
      this.orderdetail.comments += ", Tax Cert: " + this.selectedTaxCertificate;
    } else {
      this.orderdetail.comments = "Tax Cert: " + this.selectedTaxCertificate;
    }
    this.commentslength = this.orderdetail.comments.length;
    this.taxCertificatesDialog.opened = false;
  }

  //#region Paint Disclaimer
  shouldShowPaintDisclaimerMsg: boolean = false;
  paintDisclaimerMsg: string;
  protected isPaintDisclaimerApplicable() {
    this.shouldShowPaintDisclaimerMsg = false;
    try {
      if (this.quoteService.kdQuoteItems) {
        for (var i = 0; i < this.quoteService.kdQuoteItems.length; i++) {
          if (this.quoteService.kdQuoteItems[i].finishValue == "22") {
            this.shouldShowPaintDisclaimerMsg = this.quoteService.isDisclaimerMessageOfPaintApplicable(this.quoteService.kdQuoteItems[i].paint);
            if (this.shouldShowPaintDisclaimerMsg) {
              break;
            }
          }
        }
      }
    }
    catch (e) {
      //dont do anything
    }
  }
  //#endregion

  //#region CC related changes
  frieghtTermsPrePaidLbl: 'Prepaid';
  frieghtTermsEstLbl: 'Estimate & include with order*';
  frieghtTermsEstMsgLbl: '*Shipping Cost is estimated and subject to change at time of order entry';
  frieghtTermsPickupLbl: 'Pickup**';
  frieghtTermsCollectLbl: 'Collect';
  frieghtTermsPrePaidText: 'Calculated & added to invoice at time of shipment';
  frieghtTermsPickupMsgLbl: '** Shiping costs may still be applicable for pickup Orders depanding upon the products originating location';
  public freightAmount: number = 0;
  public ccCustomer: boolean = false;
  public checkOutCConlyCustomer: boolean = false;
  public checkOutCCCustomer: boolean = false;
  public freightEstimateFlag: boolean = false;
  public freightEstimateNoteFlag: boolean = false;
  public freightTermsCalculation: string = '';
  public isFreightTermsError: boolean = false;
  public isFreightTermMessage: boolean = false;
  public isFreightTermsErrorMsg: string = '';
  public isRetry: boolean;
  selectedFreightTermsIdForCCOrder = -1;
  public freightTermSelection: number = 0;
  async SwitchFrieghtInclude(event) {
    this.isFreightTermsError = false;
    if (this.checkoutService.prepaidFreightSelected) {
      await this.calculateFreightAmount();
    }
  }
  //#region Freight Calc
  async selectFreightTerms(event) {
    this.checkoutService.prepaidFreightSelected = false;
    this.isFreightTermsError = false;
    this.freightTermSelection = 0;
    var selectedTermsId = parseInt(this.orderdetail.freightTerms.value);
    if (selectedTermsId == 1 && this.orderdetail.freightTerms.name.toLowerCase().indexOf('standard shipment') > -1) {
      this.freightTermSelection = 1;
    } else if (selectedTermsId == 4) {
      this.freightTermSelection = 2;
    }
    this.isRetry = false;
    this.isFreightTermMessage = false;
    if (selectedTermsId == 3) {
      this.isFreightTermMessage = true;
    }
    
    this.freightTermsCalculation = selectedTermsId.toString();
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.selectedFreightTermsIdForCCOrder = selectedTermsId;
    this.isFreightTermsError = false;   
  }
  async selectLeed() {
    if (this.checkoutService.prepaidFreightSelected) {
      this.calculateFreightAmount();
    }
  }

  shippingDevNote = '';

  async calculateFreightAmount() {
    this.freightAmount = 0;
    this.isRetry = false;
    this.checkoutService.checkOutProcessModel.freightAmount = 0;
    this.isFreightTermsError = false;
    this.isFreightTermsErrorMsg = '';
    this.checkoutService.freightCalcInProgress = true;
    this.orderDetailsForm.isFreightCalcSuccessfull = false;
    this.shippingDevNote = '';
    this.checkoutService.calculateFreightAmountForExpressCheckout(this.checkOutProcessModel, this.selectedQuoteHeader.quoteCommonId, true)
      .subscribe((response: ICreditCardFreightAmount) => {
        this.checkoutService.freightCalcInProgress = false;
        if (!response.isError) {
          this.freightAmount = response.freightAmount;
          this.checkoutService.checkOutProcessModel.freightAmount = this.freightAmount;
          this.checkoutService.checkOutProcessModel.freightUniqueId = response.message;
          this.checkOutProcessModel.freightUniqueId = response.message;
          this.orderDetailsForm.isFreightCalcSuccessfull = true;
          console.log("Shipping Note: " + response.shipmentNote);
          this.shippingDevNote = response.shipmentNote;
          this.validateCheckoutDetails(true);
        } else {
          //this.isRetry = true;
          this.checkoutService.prepaidFreightSelected = false;
          this.isFreightTermsError = true;
          this.isFreightTermsErrorMsg = response.message;
          this.isFreightTermsErrorMsg = "Sorry an error occured while calculating freight amount. Please try again. If you get error again";
          if (response.isRetryDisable) {
           this.isFreightTermsErrorMsg = response.message;
           this.isRetry = false;
          }
          /*this.shippingDevNote = response.message;*/
          this.validateCheckoutDetails(true);//show another message to user to select collect or 
        }
      });
  }
  public get freightExpressEstimatedShipping(): number {
    if (this.checkoutService.checkOutProcessModel.freightAmount) {
      return this.checkoutService.checkOutProcessModel.freightAmount;
    }
    return 0;
  }
  public get freightCalcInProcess() {
    return this.checkoutService.freightCalcInProgress;
  }

  processCheckoutChargeToAccount() {
    this.isConfirmCheckoutBtnClicked = true;
    this.showErrorIndicatorToUser = true;
    if (!this.validateCheckoutDetails(false)) { return false; }
    this.handleCheckoutInProgress();
    this.checkoutService.expressCheckoutChargeToAccount(this.checkOutProcessModel, this.selectedQuoteHeader.quoteCommonId).subscribe((response: IBaseResponse) => {

      //hope everything is successfull & order acknoledge number is received.
      if (!response.isError) {
        //this.orderAcknowledgementDialog.opened = true;
        //this.orderAcknowledgementDialog.acknowledgeNumber = response.data.toString(); //assign order acknoledge number from response
        //this.cartService.totalCartItem.next(0);
        //this.orderInProcess = false;
        //this.checkoutService.reset();
        this.kdRefNumber = response.data.toString();
        try {
          this.sendLogToGoogleAnalytics(this.kdRefNumber);
        }
        catch (e) { }
        this.handleCheckoutSuccess();
      } else {
        //this.orderAcknowledgementDialog.opened = true;
        //this.orderAcknowledgementDialog.isError = true;
        //this.orderInProcess = false;
        this.handlecheckoutError();
      }

    });
  }
  protected openPaymentWithCCDialog() {
    this.creditCardCharge = 0;
    this.creditCardTotalAmount = 0;
    this.cCPaymentConfirmationDialog = false;
    if (this.validateCheckoutDetails(true)) {
      this.cCPaymentConfirmationDialog = true;
      this.creditCardCharge = (this.checkoutService.checkOutProcessModel.freightAmount + this.checkOutProcessModel.orderTotal) * 3/100;
      this.checkoutService.checkOutProcessModel.creditCardCharge = this.creditCardCharge;
      this.creditCardTotalAmount = this.checkoutService.checkOutProcessModel.freightAmount + this.checkOutProcessModel.orderTotal + this.creditCardCharge;
    } else {
      return false;
    }
  }
  protected ClosePaymentWithCCDialog() {
    this.cCPaymentConfirmationDialog = false;
  }
  //#endregion
  processCheckoutCC() {
    this.isConfirmCheckoutBtnClicked = true;
    this.cCPaymentConfirmationDialog = false;
    this.showErrorIndicatorToUser = true;
    if (!this.validateCheckoutDetails(true)) { return false; }
    this.handleCheckoutInProgress();
    let isSafari = false;// this.isSafari();
    if (isSafari) {
      this.checkoutService.browserName = "safari";
    }
    /*  console.log(this.checkOutProcessModel);*/
    this.checkoutService.getCreditCardExpressCheckOutRequestId(this.checkOutProcessModel, this.selectedQuoteHeader.quoteCommonId).subscribe((response: any) => {
      //hope everything is successfull & order acknoledge number is received.
      //return;//for test only
      if (!response.isError) {
        this.checkoutService.ccActionUrl = response.actionUrl;
        this.checkoutService.ccRequestId = response.ccPayload.requestId;
        this.checkoutService.ccTrackerId = response.ccPayload.trackerId;
        if (this.checkoutService.browserName == 'safari') {
          window.open(response.actionUrl, '_blank');
        } else {
          this.transform();
          this.openPaymentPortal();
        }
      }
      else {
        //show error to the user
      }
    });
  }
  openPaymentPortal() {
    this.showPaymentDialog = true;
    this.paymentPortalInitializing = true;
    timer(8000)
      .subscribe(t => { this.paymentPortalInitializing = false });
  }
  closePaymentPortal() {
    this.checkoutInProgress = false;
    this.showPaymentDialog = false;
    this.paymentPortalInitializing = false;
  }
  paymentPortalInitializing = true;
  showPaymentDialog = false;
  actionUrl: string = "";
  url: any;
  transform() {
    this.actionUrl = this.checkoutService.ccActionUrl;
    if (this.actionUrl) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionUrl);
      this.checkoutService.ccActionUrl = "";//url will be used only once
    }
  }
  async cancelOrder() {
    //do other required steps
    if (this.checkoutService.ccTrackerId) {
      var request = { "trackerId": this.checkoutService.ccTrackerId };
      //do other required steps
      try {
        var paymentResponse = await this.checkoutService.cancelCreditCardCheckout(request).toPromise();
        this.closePaymentPortal();
      }
      catch (e) {
      }
    } else {
      // cancelCreditCardCheckout(data: any)
      this.closePaymentPortal();
    }
  }
  //#endregion
}
